<script lang="ts">
	let headlineClass = "";
	export { headlineClass as class };
</script>

<h2 class=" {headlineClass} font-spaceGrotesk rounded-lg p-4 text-center lg:text-3xl">
	<slot />
</h2>
